import { useConfig } from '../context/Config';
import { useIcon } from '../context/Icons';
import { AspectRatioSizer } from './AspectRatioSizer';
import { CheckerBoardBackground } from './CheckerBoardBackground';
import { PreviewLoadingAnimation } from './PreviewLoadingAnimation';
import { Svg } from './Svg';

export const Preview = () => {
  const { stageIcon } = useIcon();
  const { listItemStyles } = useConfig();

  if (stageIcon) {
    return (
      <div className="icon-library--preview flex flex-grow relative">
        {stageIcon.svg ? (
          <div className={`flex items-center justify-center flex-grow animate-fade`}>
            <AspectRatioSizer>
              <CheckerBoardBackground />
              {stageIcon.colorizedSvg ? <Svg svg={stageIcon.colorizedSvg} /> : <Svg svg={stageIcon.svg} />}
            </AspectRatioSizer>
          </div>
        ) : (
          <PreviewLoadingAnimation url={stageIcon.previewUrl} customStyles={listItemStyles} />
        )}
      </div>
    );
  }
  return null;
};
